import React, { createContext, useState, useEffect } from 'react'

// Get WordPress site URL from window.location
export const SITE_URL = window.location.origin
export const BASE_PATH = window.location.pathname.replace(/\/[^/]*$/, '')
export const NavigationContext = createContext()

export function NavigationProvider({ children }) {
  const [currentSlug, setCurrentSlug] = useState(() => {
    // Extract clean path segment, removing any nested routes
    const fullPath = window.location.pathname
    const cleanPath = fullPath.split('/').filter(Boolean).pop() || 'front-page'
    return cleanPath
  })

  useEffect(() => {
    const pageTitle = {
      'front-page': 'Home | Dara Brexendorf',
      'publikationen': 'Publikationen | Dara Brexendorf',
      'vita': 'Vita | Dara Brexendorf',
      'workshops': 'Workshops | Dara Brexendorf'
    }

    document.title = pageTitle[currentSlug] || 'Dara Brexendorf'
  }, [currentSlug])

  return (
    <NavigationContext.Provider value={{ currentSlug, setCurrentSlug }}>
      {children}
    </NavigationContext.Provider>
  )
}